import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  arubaCentral: 'Aruba Central',
  computeOpsManagement: 'Compute Ops Management',
  dataServices: 'Data Services',
  hpeGreenLakeFlex: 'HPE GreenLake Flex Solutions',
  // hpeGreenLakePlatform: 'HPE GreenLake Platform',
};

export const arubaCentralOptions: FormOptions = {
  billing: 'Billing',
  orders: 'Orders',
  quotes: 'Quotes',
  subscription: 'Subscription',
};

export const computeOpsManagementOptions: FormOptions = {
  billing: 'Billing',
  evaluationSubscriptions: "Evaluation Subscriptions",
  // metering: 'Metering',
  orders: 'Orders',
  quotes: 'Quotes',
  subscriptions: 'Subscriptions',
};

export const computeOpsManagementOrdersOptions: FormOptions = {
  submittedOrder: 'Submitted order',
  newSubscriptionOrder: 'New subscription order',
};

export const dataServicesOptions: FormOptions = {
  billing: 'Billing',
  evaluationSubscriptions: "Evaluation Subscriptions",
  metering: 'Metering',
  orders: 'Orders',
  quotes: 'Quotes',
  subscriptions: 'Subscriptions',
};

export const hpeGreenLakeFlexOptions: FormOptions = {
  capacityPlanning: 'Capacity planning',
  consumptionAnalytics: 'Consumption analytics',
  metering: 'Metering',
  monthlyCharges: 'Monthly charges',
  orders: 'Orders',
  partnerBillingAccountsManager: 'Partner billing accounts manager',
};

export const hpeGreenLakePlatformOptions: FormOptions = {
  partnerBillingAccountsManager: 'Partner billing accounts manager'
};

export const meteringOptions: string[] = [
  '3PAR',
  'Alletra',
  'Azure Stack',
  'Azure Stack HCI',
  'Blades',
  'BMaaS',
  'CaaS',
  'Cloudline',
  'Cohesity',
  'DL Servers',
  'EDF Cluster',
  'Edgeline',
  'EL300',
  'Electronic Health Record',
  'Google Anthos',
  'GreenLake Managed Service',
  'Hedvig',
  'HPCaaS',
  'Hyperscale',
  'LeftHand',
  'Linux Utilization',
  'MLOps',
  'Moonshot',
  'Network Switch',
  'Nimble',
  'NonStop Core',
  'Nutanix',
  'P2000',
  'PCaaS',
  'Primera',
  'Qumulo',
  'Rubrik Cluster',
  'SAN',
  'SAP HANA',
  'SAP S/4HANA pe',
  'Scality',
  'Software Licenses',
  'StoreOnce',
  'Synergy',
  'Vcms',
  'Veeam BU Storage',
  'VM',
  'VM SDS 1.0',
  'VMaaS',
  'Windows Utilization',
  'XP',
  'Other',
];
